import applyWin32StyleToMailRibbonConfiguration from '../actions/applyWin32StyleToMailRibbonConfiguration';
import onWin32StyleEnabledChanged from 'owa-theme-win32-style-store/lib/actions/onWin32StyleEnabledChanged';
import { orchestrator } from 'satcheljs';

orchestrator(onWin32StyleEnabledChanged, actionMessage => {
    applyWin32StyleToMailRibbonConfiguration(actionMessage.isEnabled);
});
